export default __webpack_public_path__ + "static/media/tick-image.7b6dbf71.png";